"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.contactEnrichmentEpic = exports.contactEnrichmentPollingEpic = void 0;

var _reduxObservable = require("redux-observable");

var _operators = require("rxjs/operators");

var _rxjs = require("rxjs");

var _contactEnrichment = require("./contactEnrichment.types");

var _contactEnrichment2 = require("./contactEnrichment.actions");

var contactEnrichmentPollingEpic = function contactEnrichmentPollingEpic(action$, state$, _ref) {
  var createGiftService = _ref.createGiftService,
      errorHandler = _ref.messagesService.errorHandler;
  return action$.pipe((0, _reduxObservable.ofType)(_contactEnrichment.CONTACT_ENRICHMENT.RESEARCH), (0, _operators.switchMap)(function (_ref2) {
    var enrichmentId = _ref2.payload;
    return (0, _rxjs.timer)(0, 5000).pipe((0, _operators.takeUntil)(action$.pipe((0, _reduxObservable.ofType)(_contactEnrichment.CONTACT_ENRICHMENT.CANCEL, _contactEnrichment.CONTACT_ENRICHMENT.COMPLETE, _contactEnrichment.CONTACT_ENRICHMENT.FAILED))), (0, _operators.switchMap)(function () {
      return createGiftService.getEnrichmentResult(enrichmentId).pipe((0, _operators.filter)(function (_ref3) {
        var updated = _ref3.updated;
        return updated;
      }), (0, _operators.mergeMap)(function (response) {
        return [(0, _contactEnrichment2.completeContactEnrichment)(response)];
      }), (0, _operators.catchError)(errorHandler({
        callbacks: _contactEnrichment2.failContactEnrichment
      })));
    }));
  }));
};

exports.contactEnrichmentPollingEpic = contactEnrichmentPollingEpic;
var contactEnrichmentEpic = [contactEnrichmentPollingEpic];
exports.contactEnrichmentEpic = contactEnrichmentEpic;